<template>
  <div v-if="verificaSeDeveAparecerMensagemCarencia" class="aviso-container">
    <div v-if="inadimplente && timerCarregado && !miniSidebar" class="aviso-full">
      <v-icon size="24" color="yellow" class="aviso-icon-full">mdi-alert</v-icon>
      <div class="aviso-texto">
        <div v-if="bloqueioAmanhaSemCarencia" class="aviso-mensagem-especial">Sua conta será bloqueada amanhã</div>
        <template v-else>
          <div class="aviso-texto-bloqueio">O Sistema será bloqueado em</div>
          <div class="aviso-texto-dias-restantes">{{ dataBloqueioFormatada }}. Falta {{ diasFormatados }} {{ textoDia }}</div>
        </template>
      </div>
    </div>
    <v-tooltip v-else-if="inadimplente && timerCarregado && miniSidebar" bottom>
      <template #activator="{ on, attrs }">
        <div class="aviso-icon-mini" v-bind="attrs" v-on="on">
          <v-icon size="24" color="yellow">mdi-alert</v-icon>
        </div>
      </template>
      <span class="tooltip-text">
        <div v-if="bloqueioAmanhaSemCarencia">Sua conta será bloqueada amanhã</div>
        <template v-else>
          <div class="aviso-tooltip-bloqueio">O Sistema será bloqueado em {{ dataBloqueioFormatada }}</div>
          <div class="aviso-tooltip-dias">Falta {{ diasFormatados }} {{ textoDia }}</div>
        </template>
      </span>
    </v-tooltip>
  </div>
</template>
<script lang="ts">
import { AlertaSimplesAsync } from '@/helpers/MensagemHelper';
import AuthUserModel from '@/models/Auth/AuthUserModel';
import Vue from 'vue';
import { decode, getToken, removeToken } from '../../utils/Token';
import { CoresHelper } from '@/utils/coresHelper';
import NavigationHelper from '@/helpers/NavigationHelper';
import DateHelper from '@/helpers/DateHelper';

export default Vue.extend({
  props: {
    miniSidebar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timer: '',
      auth: new AuthUserModel(),
      roleUsuario: decode(getToken()).role,
      dataBloqueio: null as Date | null,
      diasUteisRestantes: 0,
    };
  },
  created() {
    this.inicializar();
  },
  computed: {
    seconds() {
      return 1000;
    },

    minutes() {
      return this.seconds * 60;
    },

    hours() {
      return this.minutes * 60;
    },

    days() {
      return this.hours * 24;
    },

    timerCarregado() {
      return this.timer !== '' && this.timer !== null && this.timer !== undefined;
    },

    inadimplente() {
      if (this.bloqueioAmanhaSemCarencia) {
        return true;
      }
      const diasRestantes = this.diasUteisRestantes > 0
        ? this.diasUteisRestantes
        : Number(this.timer);
      return diasRestantes <= 5;
    },

    verificaSeDeveAparecerMensagemCarencia() {
      return this.auth.dataInadimplencia && this.roleUsuario === 'Admin';
    },

    bloqueioAmanhaSemCarencia(): boolean {
      return this.auth.bloqueioAmanha === 'true' || this.auth.bloqueioAmanha === true;
    },

    dataBloqueioFormatada(): string {
      if (this.auth.dataBloqueio) {
        return DateHelper.formatoBR(this.auth.dataBloqueio);
      }
      if (!this.dataBloqueio) return '';
      return DateHelper.formatoBR(this.dataBloqueio.toISOString());
    },

    diasFormatados(): string {
      const dias = this.diasUteisRestantes > 0
        ? this.diasUteisRestantes
        : Number(this.timer);
      return this.formatNumber(dias);
    },
    textoDia(): string {
      const dias = this.diasUteisRestantes > 0
        ? this.diasUteisRestantes
        : Number(this.timer);
      return dias === 1 ? 'dia útil' : 'dias úteis';
    },

    mensagemFormatada(): string {
      if (!this.dataBloqueioFormatada || !this.timer) return '';
      const primeiraParte = `O Sistema será bloqueado em ${this.dataBloqueioFormatada}.`;
      const segundaParte = `Falta ${this.timer} ${this.textoDia}`;
      return `${primeiraParte} ${segundaParte}`;
    },
  },
  methods: {
    inicializar() {
      const sessaoUsuario = decode(getToken());
      this.auth = sessaoUsuario;
      if (this.auth.dataBloqueio && this.auth.diasUteisRestantes !== undefined) {
        this.dataBloqueio = new Date(this.auth.dataBloqueio);
        this.diasUteisRestantes = Number(this.auth.diasUteisRestantes) || 0;
        this.timer = this.formatNumber(this.diasUteisRestantes);
        this.vencimento();
      } else {
        this.vencimento();
      }
    },
    calcularDiasUteis(dataInicio: Date, dataFim: Date): number {
      const hoje = new Date(dataInicio);
      hoje.setHours(0, 0, 0, 0);
      const bloqueio = new Date(dataFim);
      bloqueio.setHours(0, 0, 0, 0);
      if (hoje.getTime() === bloqueio.getTime()) {
        return 0;
      }
      let diasUteis = 0;
      const dataAtual = new Date(hoje);
      dataAtual.setDate(dataAtual.getDate() + 1);
      while (dataAtual <= bloqueio) {
        const diaSemana = dataAtual.getDay();
        if (diaSemana !== 0 && diaSemana !== 6) {
          diasUteis++;
        }
        if (dataAtual.getTime() === bloqueio.getTime()) {
          break;
        }
        dataAtual.setDate(dataAtual.getDate() + 1);
      }

      return diasUteis;
    },
    adicionarDiasUteis(dataInicio: Date, diasUteisParaAdicionar: number): Date {
      const data = new Date(dataInicio);
      data.setHours(0, 0, 0, 0);
      let diasUteisContados = 0;

      data.setDate(data.getDate() + 1);

      while (diasUteisContados < diasUteisParaAdicionar) {
        const diaSemana = data.getDay();
        if (diaSemana !== 0 && diaSemana !== 6) {
          diasUteisContados++;
        }
        if (diasUteisContados < diasUteisParaAdicionar) {
          data.setDate(data.getDate() + 1);
        }
      }
      return data;
    },
    vencimento() {
      const timer = setInterval(() => {
        if (this.auth.dataBloqueio && this.auth.diasUteisRestantes !== undefined) {
          const hojeDate = new Date();
          hojeDate.setHours(0, 0, 0, 0);
          const bloqueioDate = new Date(this.auth.dataBloqueio);
          bloqueioDate.setHours(0, 0, 0, 0);
          const diasUteis = this.calcularDiasUteis(hojeDate, bloqueioDate);
          this.diasUteisRestantes = diasUteis;
          this.timer = this.formatNumber(diasUteis);

          if (bloqueioDate.getTime() < hojeDate.getTime()) {
            clearInterval(timer);
            AlertaSimplesAsync('Sistema bloqueado por inadimplência! Entre em contato com o suporte.', '', 'error');
            this.$store.dispatch('usuario/atualizarImagem', null);
            removeToken();
            this.$vuetify.theme.dark = false;
            CoresHelper.limparEspecialidade();
            NavigationHelper.navigate('login');
          }
        } else {
          const timeZone = new Date().getTimezoneOffset() * 60 * 1000;
          const hoje = new Date().getTime() + timeZone;
          const vencimento = new Date(this.auth.dataInadimplencia).getTime();
          const dataVencimento = new Date(vencimento);
          dataVencimento.setHours(0, 0, 0, 0);
          const carenciaDias = Number(this.auth.carencia) || 0;
          const bloqueio = this.adicionarDiasUteis(dataVencimento, carenciaDias);
          this.dataBloqueio = bloqueio;

          const hojeDate = new Date();
          hojeDate.setHours(0, 0, 0, 0);
          const bloqueioDate = new Date(bloqueio);
          bloqueioDate.setHours(0, 0, 0, 0);
          const diasUteis = this.calcularDiasUteis(hojeDate, bloqueioDate);
          if (bloqueioDate.getTime() < hojeDate.getTime()) {
            clearInterval(timer);
            AlertaSimplesAsync('Sistema bloqueado por inadimplência! Entre em contato com o suporte.', '', 'error');
            this.$store.dispatch('usuario/atualizarImagem', null);
            removeToken();
            this.$vuetify.theme.dark = false;
            CoresHelper.limparEspecialidade();
            NavigationHelper.navigate('login');
          }

          this.diasUteisRestantes = diasUteis;
          this.timer = this.formatNumber(diasUteis);
        }
      }, 1000);
    },
    formatNumber(number: number): any {
      return number < 10 ? `0${number}` : number;
    },
  },
});
</script>
<style scoped>
.aviso-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  min-height: 50px;
  padding: 0.5rem;
  margin-right: 0;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mensagem-texto {
  margin-left: 8px;
  font-size: 0.85rem;
  font-weight: 500;
  line-height: 1.3;
  color: #ffffff;
  padding: 0.65rem 1rem;
  margin: 0;
}

.aviso-full {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 0.5rem;
}

.aviso-icon-full {
  flex-shrink: 0;
  margin-top: 2px;
}

.aviso-texto {
  color: white;
  font-size: 1rem;
  line-height: 1.4;
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}

.aviso-texto-bloqueio {
  display: block;
  white-space: nowrap;
}

.aviso-texto-dias-restantes {
  display: block;
  white-space: nowrap;
}

.aviso-mensagem-especial {
  display: block;
  word-wrap: break-word;
  line-height: 1.4;
  padding-left: 0.5rem;
  font-weight: bold;
  font-size: 1.2rem;
}

.aviso-icon-mini {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem;
  width: 100%;
}

.tooltip-text {
  text-align: center;
  line-height: 1.5;
}
</style>


